import * as React from "react";
import { useState } from "react";
import { useNavigate } from "react-router";
import Collapse from "react-bootstrap/Collapse";
import { useAppDispatch } from "../../store/index";
import { ProgramClassItem, ProgramResponse } from "../../interfaces/program";
import { formatMoney } from "../../../shared/api/formatutil";
import { formatDateRangeSimple } from "../../../shared/api/time";
import { CartItemProgramClass } from "../../interfaces/cart";
import { getNewCheckout } from "../../api/checkout";
import { getCartItemId } from "../../api/cart";
import { setCheckout } from "../../reducers/checkout";
import { setCart } from "../../reducers/cart";
import ProgramClassFormat from "./programclassformat";
import ProgramClassSchedule from "./programclassschedule";
import MeetingTimeSummary from "./meetingtimesummary";
import ToggleSchedule from "../../components/toggleschedule";

interface ProgramClassProps {
    programclass: ProgramClassItem;
    program: ProgramResponse;
}

const ProgramClass = ({ programclass, program }: ProgramClassProps) => {
    const [showSchedule, setShowSchedule] = useState(false);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const dateName = formatDateRangeSimple(
        programclass.firstScheduleDateMs,
        programclass.lastScheduleDateMs,
        programclass.timezone,
    );

    const onRegister = () => {
        // create a new checkout
        const newCheckout = getNewCheckout(
            program.providerName,
            program.providerId,
            program.providerCode,
        );
        const updatedCheckout = {
            ...newCheckout,
            termsHtml: program.termsHtml,
        };

        dispatch(setCheckout(updatedCheckout));

        const description = `Classes: ${dateName}`;

        // create a new cart
        const newCartItem: CartItemProgramClass = {
            itemType: "programClass",
            id: getCartItemId(),
            name: program.programName,
            description: description,
            price: program.price,
            programClassId: programclass.programClassId,
            productId: programclass.productId,
            programId: program.programId,
        };
        const newCart = {
            items: [newCartItem],
            description: `${program.programName} (${description})`,
        };
        dispatch(setCart(newCart));
        // console.log("cart item created", newCartItem);
        // redirect to the cart page
        navigate("/checkout/" + program.providerCode);
    };

    const toggleSchedule = () => {
        setShowSchedule((prev) => !prev);
    };

    let registerButton: React.JSX.Element;

    if (program.hasPaymentProcessor) {
        registerButton = (<button className="btn btn-primary" onClick={onRegister}>
            Register
        </button>);
    }
    else {
        registerButton = (<button className="btn btn-primary" disabled>
            Register
        </button>);
    }

    return (
        <div className="register-classcontainer">
            <div className="register-classitem">
                <div className="register-class-name">
                    <div className="mb-1">
                        <ProgramClassFormat programclass={programclass} />
                    </div>
                    <div className="fw-bold">{dateName}</div>
                </div>
                <div className="register-class-times">
                    <MeetingTimeSummary
                        timezone={programclass.timezone}
                        meetings={programclass.meetings}
                    />
                </div>
                <div className="register-class-schedule">
                    <ToggleSchedule
                        toggleSchedule={toggleSchedule}
                        showSchedule={showSchedule}
                        showLabel={"Show Schedule"}
                        hideLabel={"Hide Schedule"}
                    />
                </div>
                <div className="register-class-price">
                    {formatMoney(programclass.price)}
                    <div className="register-class-schedule-link">
                        <ToggleSchedule
                            toggleSchedule={toggleSchedule}
                            showSchedule={showSchedule}
                            showLabel={"Schedule"}
                            hideLabel={"Schedule"}
                        />
                    </div>
                </div>
                <div className="register-class-button">
                    {registerButton}
                </div>
            </div>
            <Collapse in={showSchedule}>
                <div>
                    <ProgramClassSchedule programclass={programclass} />
                </div>
            </Collapse>
        </div>
    );
};

export default ProgramClass;
